import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as UserSvg } from "../../../assets/admin/menu/users.svg";
import { ReactComponent as UserFilledSvg } from "../../../assets/admin/menu/users-filled.svg";
import { ReactComponent as SupportSvg } from "../../../assets/admin/menu/support.svg";
import { ReactComponent as SupportFilledSvg } from "../../../assets/admin/menu/support-filled.svg";
import { ReactComponent as LandingSvg } from "../../../assets/admin/menu/landing.svg";
import { ReactComponent as LandingFilledSvg } from "../../../assets/admin/menu/landing-filled.svg";
import { ReactComponent as VerifySvg } from "../../../assets/admin/menu/verify.svg";
import { ReactComponent as VerifyFilledSvg } from "../../../assets/admin/menu/verify-filled.svg";
import { ReactComponent as TicketsSvg } from "../../../assets/admin/menu/tickets.svg";
import { ReactComponent as TicketsFilledSvg } from "../../../assets/admin/menu/tickets-filled.svg";
import { ReactComponent as BlogSvg } from "../../../assets/admin/menu/blog.svg";
import { ReactComponent as BlogFilledSvg } from "../../../assets/admin/menu/blog-filled.svg";
import { ReactComponent as FaqSvg } from "../../../assets/admin/menu/faq.svg";
import { ReactComponent as FaqFilledSvg } from "../../../assets/admin/menu/faq-filled.svg";
import OutsideClickHandler from "react-outside-click-handler";
import { Button, Notify } from "../..";
import "../../../styles/admin.scss";
import AppContext from "../../../AppContext";

import hamburgerPng from "../../../assets/icons/hamburger-2.svg";
import { SocketContext } from "../../../contexts/SocketContext";

const assetsUri = import.meta.env.ASSETS_URI;

const MenuItem = ({
  title,
  notificationCount,
  idleIcon: IdleIcon,
  activeIcon: ActiveIcon,
  to,
}) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `admin-menu-lists-item ${
          isActive
            ? "admin-menu-lists-item--active"
            : "admin-menu-lists-item--inactive"
        }`
      }
    >
      <div className="admin-menu-lists-item__icon">
        <ActiveIcon className="admin-menu-lists-item__icon--active" />
        <IdleIcon className="admin-menu-lists-item__icon--inactive" />
      </div>
      <label className="admin-menu-lists-item__title">{title}</label>
      <Notify count={notificationCount || 0} />
    </NavLink>
  );
};

const AdminMenu = () => {
  const urlPrefix = "/admin";
  const navigate = useNavigate();
  const { user, setToken, isAuth } = useContext(AppContext);
  const [toggle, setToggle] = useState(false);
  const { disconnect } = useContext(SocketContext);

  const handleSignOut = () => {
    disconnect();
    setToken(undefined);
  };

  const handleToggleClick = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <div className="admin-menu-hamburger" onClick={handleToggleClick}>
        <img
          className="admin-menu-hamburger__icon"
          alt="menu"
          src={hamburgerPng}
        />
      </div>
      <OutsideClickHandler onOutsideClick={() => setToggle(false)}>
        <div className={`admin-menu ${!toggle ? "admin-menu--hide" : ""}`}>
          <div className="admin-menu-header">
            <img
              className="admin-menu-header__image"
              src={`${assetsUri}/${user.avatar}`}
            />
            <div className="admin-menu-header-info">
              <div className="admin-menu-header-info__name">{`${user.firstname} ${user.lastname}`}</div>
              <div className="admin-menu-header-info__email"></div>
            </div>
          </div>
          <div className="admin-menu-lists">
            <MenuItem
              title="Users"
              notificationCount={0}
              idleIcon={UserSvg}
              activeIcon={UserFilledSvg}
              to={`${urlPrefix}/users`}
            />
            <MenuItem
              title="Landing Page"
              idleIcon={LandingSvg}
              activeIcon={LandingFilledSvg}
              to={`${urlPrefix}/landing-pages`}
            />
            <MenuItem
              title="Support Chat"
              notificationCount={0}
              idleIcon={SupportSvg}
              activeIcon={SupportFilledSvg}
              to={`${urlPrefix}/chat`}
            />
            <MenuItem
              title="Verifications"
              notificationCount={0}
              idleIcon={VerifySvg}
              activeIcon={VerifyFilledSvg}
              to={`${urlPrefix}/verifications`}
            />
            <MenuItem
              title="Support Tickets"
              notificationCount={0}
              idleIcon={TicketsSvg}
              activeIcon={TicketsFilledSvg}
              to={`${urlPrefix}/tickets`}
              defaultPath="/open"
            />
            <MenuItem
              title="Blog"
              notificationCount={0}
              idleIcon={BlogSvg}
              activeIcon={BlogFilledSvg}
              to={`${urlPrefix}/blog`}
              defaultPath="/open"
            />
            <MenuItem
              title="FAQ"
              notificationCount={0}
              idleIcon={FaqSvg}
              activeIcon={FaqFilledSvg}
              to={`${urlPrefix}/faq`}
              defaultPath="/open"
            />
          </div>
          <div className="menu-bar-button-signout">
            <Button
              label="Logout"
              // leadingIcon={<SignOutSvg />}
              style={{ width: "260px" }}
              onClick={handleSignOut}
            />
          </div>
        </div>
      </OutsideClickHandler>
    </>
  );
};

AdminMenu.propTypes = {};

export default AdminMenu;
